import { Injectable } from '@angular/core';
import { IGroup, IGroups, IUserAccessToGroup } from '@interfaces/IGroup';
import { IAppState } from '@myStore/app.state';
import {
  EGroupsViewActions,
  GetActiveCourseGroupsFailure,
  GetActiveCourseGroupsRequest,
  GetActiveCourseGroupsSuccess,
  GetAllCourseGroupsFailure,
  GetAllCourseGroupsRequest,
  GetAllCourseGroupsSuccess,
  GetGroupDetailFailure,
  GetGroupDetailRequest,
  GetGroupDetailSuccess,
  GetGroupsFailure,
  GetGroupsRequest,
  GetGroupsSuccess,
  GetInactiveCourseGroupsFailure,
  GetInactiveCourseGroupsRequest,
  GetInactiveCourseGroupsSuccess,
  GetStudentAccessFailure,
  GetStudentAccessRequest,
  GetStudentAccessSuccess,
  GetStudentsTransfersGroupsFailure,
  GetStudentsTransfersGroupsRequest,
  GetStudentsTransfersGroupsSuccess,
} from '@myStore/groups-view/groups-view.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { GroupsViewService } from '@services/groups-view/groups-view.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class GroupsViewEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _toastr: ToastrService,
    private _groupsViewService: GroupsViewService
  ) {}

  $getGroupDetail = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetGroupDetailRequest>(EGroupsViewActions.GetGroupDetailRequest),
        map(action => action),
        switchMap(action => {
          return this._groupsViewService.getGroupDetail(action.id).pipe(
            map((group: IGroup) => {
              this._store.dispatch(new GetGroupDetailSuccess(group));
            }),
            catchError(err => {
              this._toastr.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'При получении деталей групп возникла ошибка'
                }`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new GetGroupDetailFailure(err.error));
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $getGroups = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetGroupsRequest>(EGroupsViewActions.GetGroupsRequest),
        switchMap(action => {
          return this._groupsViewService.getGroups(action.qParams).pipe(
            map((groups: IGroups) => {
              this._store.dispatch(new GetGroupsSuccess(groups));
            }),
            catchError(err => {
              this._toastr.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'При получении групп возникла ошибка'
                }`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new GetGroupsFailure(err.error));
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $getAllCourseGroups = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetAllCourseGroupsRequest>(
          EGroupsViewActions.GetAllCourseGroupsRequest
        ),
        map(action => action),
        switchMap(action => {
          return this._groupsViewService.getAllCourseGroups(action.id).pipe(
            map((groups: IGroups) => {
              this._store.dispatch(new GetAllCourseGroupsSuccess(groups));
            }),
            catchError(err => {
              this._toastr.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'При получении групп у курса возникла ошибка'
                }`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new GetAllCourseGroupsFailure(err.error));
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $getActiveCourseGroups = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetActiveCourseGroupsRequest>(
          EGroupsViewActions.GetActiveCourseGroupsRequest
        ),
        map(action => action),
        switchMap(action => {
          return this._groupsViewService
            .getActiveCourseGroups(action.id, action.qParams)
            .pipe(
              map((groups: IGroups) => {
                this._store.dispatch(new GetActiveCourseGroupsSuccess(groups));
              }),
              catchError(err => {
                this._toastr.error(
                  `${
                    err?.error?.detail
                      ? err?.error?.detail
                      : 'При получении активных групп у курса возникла ошибка'
                  }`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(
                  new GetActiveCourseGroupsFailure(err.error)
                );
                return err.error;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $getInactiveCourseGroups = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetInactiveCourseGroupsRequest>(
          EGroupsViewActions.GetInactiveCourseGroupsRequest
        ),
        map(action => action),
        switchMap(action => {
          return this._groupsViewService
            .getInactiveCourseGroups(action.id)
            .pipe(
              map((groups: IGroups) => {
                this._store.dispatch(
                  new GetInactiveCourseGroupsSuccess(groups)
                );
              }),
              catchError(err => {
                this._toastr.error(
                  `${
                    err?.error?.detail
                      ? err?.error?.detail
                      : 'При получении неактивных групп у курса возникла ошибка'
                  }`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(
                  new GetInactiveCourseGroupsFailure(err.error)
                );
                return err.error;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $getStudentsTransfersGroups = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetStudentsTransfersGroupsRequest>(
          EGroupsViewActions.GetStudentsTransfersGroupsRequest
        ),
        map(action => action),
        switchMap(action => {
          return this._groupsViewService.getActiveCourseGroups(action.id).pipe(
            map((groups: IGroups) => {
              this._store.dispatch(
                new GetStudentsTransfersGroupsSuccess(groups)
              );
            }),
            catchError(err => {
              this._toastr.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'При трансфере студентов возникла ошибка'
                }`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(
                new GetStudentsTransfersGroupsFailure(err.error)
              );
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $getStudentAccess = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetStudentAccessRequest>(
          EGroupsViewActions.GetStudentAccessRequest
        ),
        switchMap(action => {
          return this._groupsViewService
            .getStudentAccess(action.groupId, action.studentId)
            .pipe(
              map((access: IUserAccessToGroup) => {
                this._store.dispatch(new GetStudentAccessSuccess(access));
              }),
              catchError(err => {
                this._toastr.error(
                  `${
                    err?.error?.detail
                      ? err?.error?.detail
                      : 'При получении доступа студента возникла ошибка'
                  }`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(new GetStudentAccessFailure(err.error));
                return err.error;
              })
            );
        })
      );
    },
    { dispatch: false }
  );
}
